import { render } from "./FooterItem.vue?vue&type=template&id=7f689064&scoped=true"
import script from "./FooterItem.vue?vue&type=script&lang=js"
export * from "./FooterItem.vue?vue&type=script&lang=js"

import "./FooterItem.vue?vue&type=style&index=0&id=7f689064&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Lenovo\\OneDrive\\Documents\\Freelance\\symphinite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f689064"]])

export default __exports__